import Vue from 'vue'
import Vant from 'vant'
import 'amfe-flexible'
import App from './App.vue'
import router from './router'
import store from './store'
import * as api from './service/api'
import 'vant/lib/index.css'
import './assets/styles/styles.less'
// import VConsole from 'vconsole'
// new VConsole()

Vue.use(Vant)
Vue.config.productionTip = false
Vue.$api = Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
